// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_dnX","cls2":"SimplePaperPodcast-cls2_j5f SimplePaperPodcast-cls1_dnX"};